import React, { useState, useEffect, useMemo } from "react";
import Icon from "../Icon/Icon.tsx";
import "./DateInput.scss";
import DatePicker from "./DatePicker/DatePicker.js";

const DateInput = ({ date, setDate, inputDirection }) => {
  const [openDatepicker, setOpenDatepicker] = useState(false);
  const [dateInput, setDateInput] = useState(date);

  useEffect(() => {
    if (date) {
      setDateInput(date);
    }
  }, [date]);

  const [selectedDate, setSelectedDate] = useState(false);
  const [randomId, setRandomId] = useState(null);
  useMemo(() => {
    setRandomId(Math.random().toString(36).substring(7));
  }, []);
  const handleChangeDate = (e) => {
    const patternDate =
      /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
    const secondPatternDate =
      /^([0]?[1-9]|[1|2][0-9]|[3][0|1])[.-]([0]?[1-9]|[1][0-2])[.-]([0-9]{4})$/;
    if (patternDate.test(e) || secondPatternDate.test(e)) {
      const datePickerState = new Date(e.trim());
      let datePickerStateArray = [];
      if (e.includes(".")) {
        datePickerStateArray = e.split(".");
      } else if (e.includes("/")) {
        datePickerStateArray = e.split("/");
      } else {
        datePickerStateArray = e.split("-");
      }
      let day = datePickerStateArray[0];
      let month = datePickerStateArray[1];
      let year = datePickerStateArray[2];
      let dateState = new Date(year, month - 1, day);
      setDate(dateState);
    } else {
      setDate("");
    }
    setDateInput(e);
  };

  const enterButtonFunction = (e) => {
    if (e.key === "Enter") {
      setOpenDatepicker((prev) => !prev);
    }
  };

  useEffect(() => {
    if (selectedDate) {
      let newDateFormat = `${date.getDate() < 10 ? "0" : ""}${date.getDate()}/${
        date.getMonth() + 1 < 10 ? "0" : ""
      }${date.getMonth() + 1}/${date.getFullYear()}`;
      setDateInput(newDateFormat);
      setSelectedDate(false);
    }
  }, [selectedDate]);

  useEffect(() => {
    //datepicker-id
    if (openDatepicker) {
      setTimeout(() => {
        const element = document.getElementById(`datepicker-id-${randomId}`);
        //scroll to element
        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 300);
    }
  }, [openDatepicker]);

  return (
    <div tabIndex={0} id={`datepicker-id-${randomId}`}>
      <div className="date-input" style={{ direction: inputDirection }}>
        <div className="div-input" style={{ direction: inputDirection }}>
          <input
            style={{ direction: inputDirection }}
            tabIndex={0}
            type="text"
            value={dateInput}
            name="date"
            placeholder="dd/mm/yyyy"
            onChange={(e) => handleChangeDate(e.target.value)}
          />
        </div>
        <div
          tabIndex={0}
          className="date-image"
          onClick={() => setOpenDatepicker((prev) => !prev)}
          onKeyDown={(e) => enterButtonFunction(e)}
        >
          <Icon name={"calendar"} />
        </div>
      </div>
      {openDatepicker && (
        <DatePicker
          setSelectedDate={setSelectedDate}
          date={date}
          setDate={setDate}
          setOpenDatepicker={setOpenDatepicker}
        />
      )}
    </div>
  );
};

export default DateInput;
